<template>
  <v-form
    @submit.prevent="balanceSwap"
    v-model="isFormValid"
    ref="form"
    class="mt-4"
  >
    <div class="mb-1 subtitle-2 grey3--text">Transfer from</div>
    <v-select
      v-model="selectedFrom"
      :items="from"
      label="From"
      dense
      outlined
    ></v-select>
    <div class="mb-1 subtitle-2 grey3--text">Transfer To</div>
    <v-select
      v-model="selectedTo"
      :items="to"
      label="To"
      dense
      outlined
    ></v-select>
    <div class="mb-1 subtitle-2 grey3--text">Amount</div>
    <v-text-field
      v-model="amount"
      :rules="[nonZeroNumberRule]"
      placeholder="Amount"
      outlined
      :disabled="amountTextField"
      dense
    ></v-text-field>
    <v-btn
      class="mt-2 info white--text lowercase-text"
      block
      plain
      :loading="$store.state.loading.swapBtn.load"
      :disabled="$store.state.loading.swapBtn.disabled"
      type="submit"
      ><v-icon left>mdi-transfer</v-icon>
      Complete transfer
    </v-btn></v-form
  >
</template>
<script>
export default {
  data: () => ({
    from: ["FlexiFund", "QuickSwap", "ShareGain"],
    to: ["TextPay", "FlexiFund", "QuickSwap"],
    selectedFrom: null,
    selectedTo: null,
    amount: null,
    isFormValid: false,
    amountTextField: false,
  }),
  computed: {
    nonZeroNumberRule() {
      return (value) => {
        if (!value) {
          return "Value is required";
        } else if (isNaN(value)) {
          return "Enter a valid number";
        } else if (parseFloat(value) === 0) {
          return "Number must not be zero";
        }
        return true;
      };
    },
  },
  methods: {
    balanceSwap() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const transactionMapping = {
        FlexiFund: {
          TextPay: "flexiPay",
          QuickSwap: "flexiQuick",
          FlexiFund: "wallets/transactionNotAllowed",
        },
        QuickSwap: {
          FlexiFund: "quickFlexi",
          TextPay: "wallets/transactionNotAllowed",
          QuickSwap: "wallets/transactionNotAllowed",
        },
        ShareGain: {
          FlexiFund: "shareFlexi",
          TextPay: "wallets/transactionNotAllowed",
          QuickSwap: "wallets/transactionNotAllowed",
        },
      };

      const selectedTransaction =
        transactionMapping[this.selectedFrom][this.selectedTo];

      if (selectedTransaction) {
        if (selectedTransaction !== "wallets/transactionNotAllowed") {
          this.$store.dispatch(`transactions/${selectedTransaction}`, {
            amount: this.amount,
          });
          this.amountTextField = true;
        } else {
          this.$store.dispatch(selectedTransaction);
        }
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
